import React from 'react';

export default function JaculatoriasSanJose() {
  return (
    <>
        Santísimo Patriarca San José <br />
        <i>Ruega por nosotros</i>
    </>
  );
}
